function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { getCategoryListByProductId, productKeyByUrlKey } from '../utils/datamappingHelpers';
import FilterItem from './filterItem';
import SpzaComponent from './spzaComponent';
import { Constants } from '../utils/constants';
import { shouldFlatProducts, shouldHideIndustriesAndProducts, shouldShowFilter } from '../../embed/embedHostUtils';
import { RichTextDropDown } from '../../shared/components/richTextDropDown';
import { shouldShowSubFilter, sortFiltersKeys, serviceOffersSupportedCountries, getCountryRegionfilterLink } from '../utils/filterHelpers';
import { serviceOffersSupportedCAStates, serviceOffersSupportedUSStates } from '@shared/utils/serviceOffersSupportedStatesCodes';
import { isEmbedded, getProductByUrlKey } from '../utils/appUtils';
import { SpzaInstrumentService } from '../services/telemetry/spza/spzaInstrument';
import { getWindow } from '../services/window';
import { getEntityRegistration } from '../utils/entityRegistration';
import { FontIcon, TooltipHost } from '@fluentui/react';
import { logger } from '@src/logger';
import { listOfUrlKeysToExcludeInAppsource } from '@shared/oneTaxonomy';
import { filterHideList } from '@shared/oneTaxonomy/utils';
import { v4 as uuidv4 } from 'uuid';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const classNames = require('classnames-minimal');
const FilterQuery = Constants.FilterQuery;
// Add a new object if need subtitles for existing products.
const subTitle = {
    2: {
        editions: [
            {
                name: 'Loc_BusinessEdition',
                products: [
                    Constants.dynamics365.financeAndOperationsBD
                ]
            },
            {
                name: 'Loc_EnterpriseEdition',
                products: [
                    Constants.dynamics365.customerInsightsED,
                    Constants.dynamics365.customerServiceED,
                    Constants.dynamics365.fieldServicesED,
                    Constants.dynamics365.financeED,
                    Constants.dynamics365.serviceAutomationED,
                    Constants.dynamics365.salesED,
                    Constants.dynamics365.marketingED,
                    Constants.dynamics365.commerceED,
                    Constants.dynamics365.supplyChainManagementED
                ]
            }
        ]
    }
};
export class FilterPane extends SpzaComponent {
    getInitialState() {
        const defaultState = {
            selectedCountry: {
                text: Constants.usFilterText,
                value: Constants.usCountryCode.toUpperCase()
            },
            selectedRegion: {
                text: Constants.allRegionsFilterText,
                value: Constants.allStatesCode.toUpperCase()
            },
            countryFilterItems: this.getCountriesFilterItems(),
            stateFilterItems: this.getStatesFilterItems(Constants.usCountryCode),
            productData: this.getCategoryID(this.props)
        };
        return defaultState;
    }
    UNSAFE_componentWillMount() {
        if (this.props.entityType && this.props.entityType === Constants.EntityType.Service) {
            this.setSelectRegionFilters(this.props);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.entityType && nextProps.entityType === Constants.EntityType.Service && (this.props.countryCode !== nextProps.countryCode || this.props.regionCode !== nextProps.regionCode)) {
            this.setSelectRegionFilters(nextProps);
        }
        if (nextProps.currentView === 'appGallery') {
            const currentProductData = this.getCategoryID(nextProps);
            this.setState({
                productData: currentProductData
            });
        }
        this.setState({
            countryFilterItems: this.getCountriesFilterItems()
        });
    }
    getCategoryID(props) {
        var _props_query;
        const productData = {};
        if (typeof ((_props_query = props.query) === null || _props_query === void 0 ? void 0 : _props_query.product) === 'string') {
            const products = props.query.product.split(';');
            if (products && products.length > 0) {
                const productFilter = products[0].trim();
                const product = getProductByUrlKey({
                    urlKey: productFilter
                });
                if (product) {
                    productData[product.FilterGroup] = product.FilterID;
                }
            }
        }
        return productData;
    }
    setSelectRegionFilters(props) {
        let selectedCountry;
        let selectedRegion;
        if (props.countryCode) {
            selectedCountry = serviceOffersSupportedCountries.filter((item)=>{
                return item.countryCode === props.countryCode;
            });
        }
        if (props.regionCode) {
            if (props.countryCode && props.countryCode.toLowerCase() === Constants.caCountryCode) {
                selectedRegion = serviceOffersSupportedCAStates.filter((item)=>{
                    return item.code === props.regionCode;
                });
            } else {
                selectedRegion = serviceOffersSupportedUSStates.filter((item)=>{
                    return item.code === props.regionCode;
                });
            }
        }
        const firstSupportedCountryIndex = this.getFirstSupportedCountryIndex();
        this.setState({
            selectedCountry: selectedCountry && selectedCountry.length > 0 ? {
                text: selectedCountry[0].name,
                value: selectedCountry[0].countryCode
            } : {
                text: serviceOffersSupportedCountries[`${firstSupportedCountryIndex}`].name,
                value: serviceOffersSupportedCountries[`${firstSupportedCountryIndex}`].countryCode
            },
            selectedRegion: selectedRegion && selectedRegion.length > 0 ? {
                text: selectedRegion[0].name,
                value: selectedRegion[0].code
            } : {
                text: serviceOffersSupportedUSStates[0].name,
                value: serviceOffersSupportedUSStates[0].code
            },
            countryFilterItems: this.getCountriesFilterItems(),
            stateFilterItems: this.getStatesFilterItems(props.countryCode)
        });
        getCountryRegionfilterLink(this.context, props.countryCode, props.regionCode);
        this.props.stateCountryFilterHandler(props.countryCode, props.regionCode);
    }
    setProductOrComplianceCategory(filter, isProductFilter) {
        if (isProductFilter) {
            if (!filter.isActive) {
                // check product filter
                const productData = {};
                productData[filter.FilterGroup] = filter.FilterID;
                this.setState({
                    productData
                });
            } else {
                // uncheck product filter
                this.setState({
                    productData: null
                });
            }
        }
    }
    getRoute() {
        return getEntityRegistration(this.props.entityType).route;
    }
    buildFilterElement(filters, filter, category, key, flat = false) {
        var _this_props_dataMap_products_;
        const isCategoryFilter = category === FilterQuery.category;
        const isIndustryFilter = category === FilterQuery.industry;
        if ((isCategoryFilter || isIndustryFilter) && !filter) {
            return;
        }
        let currentFilter = category === FilterQuery.product ? this.props.dataMap.products[productKeyByUrlKey[`${filter}`]] : filters[`${filter}`];
        if (currentFilter.IsReference) {
            currentFilter = this.props.dataMap.categories.default[`${filter}`];
        }
        const queryValue = currentFilter.UrlKey;
        const isProductFilter = category === FilterQuery.product && !flat;
        const isAppComplianceFilter = category === FilterQuery.product && !flat;
        let activeParentFilter = (currentFilter.isActive || this.props.isEmbedded) && currentFilter.ShortcutFilters != null;
        // for Office on services page, for now, we have no children
        // so we should hide the expanded icon
        if (this.props.entityType === Constants.EntityType.Service && currentFilter.BackendKey === 'Office365') {
            activeParentFilter = false;
        }
        if (currentFilter.isActive && currentFilter.SubCategoryDataMapping) {
            const visibleSubFilters = Object.keys(currentFilter.SubCategoryDataMapping).filter((filterKey)=>!listOfUrlKeysToExcludeInAppsource.includes(currentFilter.SubCategoryDataMapping[`${filterKey}`].UrlKey));
            activeParentFilter = visibleSubFilters.length > 0;
        }
        const otherProps = {};
        const children = (_this_props_dataMap_products_ = this.props.dataMap.products[`${filter}`]) === null || _this_props_dataMap_products_ === void 0 ? void 0 : _this_props_dataMap_products_.ShortcutFilters;
        if (children) {
            otherProps['aria-expanded'] = currentFilter.isActive;
        }
        if (isProductFilter) {
            otherProps['aria-pressed'] = currentFilter.isActive;
        }
        if (currentFilter.FilterID) {
            otherProps.id = category + '-' + currentFilter.FilterID;
        }
        if (isEmbedded) {
            const generatedId = uuidv4();
            otherProps.id = `${category} - ${generatedId}`;
        }
        const classNameFilterPaneRoot = 'filterPaneItemRoot' + (currentFilter.isActive ? ' taxonomy' : '');
        const hideCheckbox = isProductFilter || isAppComplianceFilter || isCategoryFilter || isIndustryFilter;
        return /*#__PURE__*/ _jsxs("li", {
            className: classNameFilterPaneRoot,
            children: [
                /*#__PURE__*/ _jsx(FilterItem, {
                    filter: currentFilter,
                    isActive: currentFilter.isActive,
                    category: category,
                    queryValue: queryValue,
                    hideCheckbox: hideCheckbox,
                    showExpandedIcon: activeParentFilter,
                    href: this.props.getFilterLink(currentFilter, this.props.query),
                    onClick: ()=>this.setProductOrComplianceCategory(currentFilter, isProductFilter),
                    role: hideCheckbox ? 'button' : 'checkbox',
                    otherProps: otherProps,
                    accEnabled: true,
                    isEmbed: this.props.isEmbedded,
                    tooltip: currentFilter.Tooltip
                }, currentFilter.FilterID),
                activeParentFilter && !flat ? /*#__PURE__*/ _jsx("ul", {
                    children: currentFilter.SubCategoryDataMapping ? this.renderSubCategories(currentFilter.SubCategoryDataMapping, FilterQuery.category) : this.renderSubFilters(currentFilter, category, filters)
                }) : null
            ]
        }, key);
    }
    renderSubCategories(filters, category) {
        const filterKeys = Object.keys(filters);
        return filterKeys.filter((filterKey)=>shouldShowSubFilter(filters[`${filterKey}`]) && !filterHideList.includes(filters[`${filterKey}`].BackendKey)).sort(function(filterKeyA, filterKeyB) {
            return sortFiltersKeys(filterKeyA, filterKeyB, filters);
        }).map((key)=>{
            const childFilter = filters[`${key}`];
            const childProps = {
                'aria-selected': childFilter.isActive
            };
            return /*#__PURE__*/ _jsx(FilterItem, {
                filter: childFilter,
                isActive: childFilter.isActive,
                category: category,
                queryValue: childFilter.UrlKey,
                hideCheckbox: false,
                href: this.props.getFilterLink(childFilter),
                otherProps: childProps
            }, childFilter.Title);
        });
    }
    renderSubFilters(currentFilter, category, filterCollection) {
        if (subTitle[`${currentFilter.FilterID}`]) {
            const subTitles = subTitle[currentFilter.FilterID].editions;
            return subTitles.map((subTitle)=>{
                return /*#__PURE__*/ _jsx("div", {
                    className: "subtitle",
                    children: this.renderChildrenFilters(subTitle.products, category, filterCollection)
                }, subTitle.name);
            });
        }
        const indentFilters = [
            this.props.dataMap.products.Dynamics365.FilterID,
            this.props.dataMap.products.PowerPlatform.FilterID
        ];
        const office = this.props.dataMap.products.Office365;
        if (office) {
            indentFilters.push(office.FilterID);
        }
        const shouldIndent = indentFilters.indexOf(currentFilter.FilterID) >= 0;
        return this.renderChildrenFilters(currentFilter.ShortcutFilters, category, filterCollection, shouldIndent);
    }
    renderChildrenFilters(ShortcutFilters, category, filters, indent) {
        return /*#__PURE__*/ _jsx("div", {
            className: indent ? 'indentCheckbox' : '',
            children: Object.keys(ShortcutFilters).map((key, index)=>{
                const childFilter = filters[ShortcutFilters[`${key}`]];
                // a child filter might be null when no apps/services with that filter are present
                if (childFilter) {
                    const childProps = {};
                    if (childFilter.isActive) {
                        childProps['aria-checked'] = childFilter.isActive;
                    }
                    return /*#__PURE__*/ _jsx(FilterItem, {
                        filter: childFilter,
                        isActive: childFilter.isActive,
                        category: category,
                        queryValue: childFilter.UrlKey,
                        href: this.props.getFilterLink(childFilter),
                        otherProps: childProps,
                        accEnabled: true
                    }, index);
                } else {
                    return null;
                }
            })
        });
    }
    renderCategoryBlock(title, filters) {
        const groupClass = 'spza_filterGroup category';
        return /*#__PURE__*/ _jsxs("div", {
            className: groupClass,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "c-heading5 spza_filterTitle",
                    children: this.context.loc(title)
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "spza_filterItems",
                    role: "list",
                    "aria-label": `${this.context.loc(title)} filter`,
                    children: Object.entries(filters).sort(([filterKeyA], [filterKeyB])=>{
                        return sortFiltersKeys(filterKeyA, filterKeyB, filters);
                    }).map(([categoryKey, categoryValue])=>{
                        const filter = categoryValue.IsReference ? this.props.dataMap.categories.default[`${categoryKey}`] : categoryValue;
                        return this.buildFilterElement(filters, categoryKey, FilterQuery.category, categoryKey, filter.HideReferenceSubCategories || false);
                    })
                })
            ]
        });
    }
    renderSearchBlock(title, filters, category) {
        const groupClass = 'spza_filterGroup ' + category;
        return /*#__PURE__*/ _jsxs("div", {
            className: groupClass,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "c-heading5 spza_filterTitle",
                    children: this.context.loc(title)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "spza_filterItems",
                    role: "listbox",
                    "aria-label": this.context.loc(title) + ' filter',
                    children: Object.keys(filters).sort(function(filterKeyA, filterKeyB) {
                        return sortFiltersKeys(filterKeyA, filterKeyB, filters);
                    }).filter((filterKey)=>!filterHideList.includes(filters[`${filterKey}`].BackendKey)).map((filter, key)=>this.buildFilterElement(filters, filter, category, key))
                })
            ]
        });
    }
    renderProductBlock(title) {
        const flat = this.props.isEmbedded && shouldFlatProducts(this.props.embedHost); // embeded admin portal
        const embedHost = this.props.isEmbedded && this.props.embedHost;
        const products = this.props.dataMap.products;
        const productGroupings = Object.keys(products).reduce(function(acc, productKey) {
            const product = products[`${productKey}`];
            if (product.IsChildFilter && !flat) {
                return acc;
            }
            if (product.BackendKey === Constants.officeBackendKey) {
                return acc;
            }
            if (product.BackendKey === Constants.adminPortalBackendKey) {
                return acc;
            }
            if (product.BackendKey === Constants.officeFlatBackendKey && flat) {
                return acc;
            }
            if (embedHost && !shouldShowFilter(embedHost, product)) {
                return acc;
            }
            acc.apps.push(product);
            return acc;
        }, {
            apps: [],
            plugins: []
        });
        const key = this.state.productData && Object.keys(this.state.productData)[0];
        const value = this.state.productData && this.state.productData[`${key}`];
        const activeDescendant = key + '_' + value;
        return /*#__PURE__*/ _jsxs("div", {
            className: "spza_filterGroup embeded-product",
            role: "listbox",
            "aria-activedescendant": !this.state.productData ? '' : activeDescendant,
            "aria-label": "Products filter",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "c-heading5 spza_filterTitle",
                    children: this.context.loc(title)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: 'spza_filterItemsNoIndent',
                    children: productGroupings.apps.filter((app)=>app).map((app, key)=>this.buildFilterElement(products, app.UrlKey, FilterQuery.product, key, flat))
                })
            ]
        });
    }
    renderDropDownFilterBlock(filterType) {
        let defaultItem = {
            text: '',
            value: ''
        };
        defaultItem = filterType === 'States' ? this.state.selectedRegion : this.state.selectedCountry;
        return /*#__PURE__*/ _jsxs("div", {
            className: "spza_dropDownFilterSection",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "spza_filterSubTitle",
                    children: this.context.loc('FilterType_' + filterType)
                }),
                /*#__PURE__*/ _jsx(RichTextDropDown, {
                    className: "regionList",
                    options: filterType === 'States' ? this.state.stateFilterItems : this.state.countryFilterItems,
                    value: defaultItem,
                    searchEnabled: filterType !== 'States',
                    onChangeHandle: (option)=>{
                        if (filterType === 'States') {
                            this.handleStateFilterSelectionChange(option);
                        } else {
                            this.handleCountryFilterSelectionChange(option);
                        }
                    },
                    dropdownLabel: filterType === 'States' ? 'state/province' : 'country/region'
                })
            ]
        });
    }
    renderAppComplianceBlock(title) {
        const flat = this.props.isEmbedded && shouldFlatProducts(this.props.embedHost); // embeded admin portal
        const complianceTypes = this.props.dataMap.appCompliance;
        const hostStyles = {
            root: {
                marginLeft: 5
            }
        };
        const complianceTypeGroupings = Object.keys(complianceTypes).reduce((acc, complianceType)=>{
            const compliance = complianceTypes[`${complianceType}`];
            acc.complianceType.push(compliance);
            return acc;
        }, {
            complianceType: [],
            plugins: []
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "spza_filterGroup embeded-product",
            role: "listbox",
            "aria-label": "AppCompliance filter",
            children: [
                /*#__PURE__*/ _jsxs("h2", {
                    className: "c-heading5 spza_filterTitle",
                    children: [
                        this.context.loc(title),
                        ' ',
                        /*#__PURE__*/ _jsx(TooltipHost, {
                            styles: hostStyles,
                            content: this.context.loc('Global_Loc_compliance_tooltip'),
                            children: /*#__PURE__*/ _jsx(FontIcon, {
                                iconName: "Info"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: 'spza_filterItemsNoIndent',
                    children: complianceTypeGroupings.complianceType.map((type, key)=>this.buildFilterElement(complianceTypes, type.UrlKey, FilterQuery.appCompliance, key, flat))
                })
            ]
        });
    }
    handleStateFilterSelectionChange(regionCode) {
        this.logfilterChangeTelemetry(this.state.selectedRegion.value, regionCode, 'state');
        this.setState({
            countryFilterItems: this.state.countryFilterItems,
            stateFilterItems: this.state.stateFilterItems,
            selectedCountry: this.state.selectedCountry,
            selectedRegion: regionCode
        });
        getCountryRegionfilterLink(this.context, this.state.selectedCountry.value, regionCode.value);
        this.props.stateCountryFilterHandler(this.state.selectedCountry.value, regionCode.value);
    }
    handleCountryFilterSelectionChange(countryCode) {
        const states = this.getStatesFilterItems(countryCode.value);
        const allStateCode = Constants.allStatesCode;
        const region = states.filter((item)=>item.value.toLowerCase() === allStateCode)[0];
        this.logfilterChangeTelemetry(this.state.selectedCountry.value, countryCode, 'country');
        this.setState({
            countryFilterItems: this.state.countryFilterItems,
            stateFilterItems: states,
            selectedCountry: countryCode,
            selectedRegion: region
        });
        getCountryRegionfilterLink(this.context, countryCode.value, region.value);
        this.props.stateCountryFilterHandler(countryCode.value, region.value);
    }
    logfilterChangeTelemetry(oldValue, newValue, type) {
        const detailsObj = {
            oldValue,
            newValue,
            filter: type
        };
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.FilterClick,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPane,
            details: JSON.stringify(detailsObj)
        };
        this.instrument.probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    renderLocationFilters() {
        const groupClass = 'spza_filterGroup locations';
        return /*#__PURE__*/ _jsxs("div", {
            className: groupClass,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "c-heading5 spza_filterTitle",
                    children: this.context.loc('FilterType_Location')
                }),
                this.renderDropDownFilterBlock('Countries'),
                this.state.selectedCountry.value.toLowerCase() === Constants.usCountryCode || this.state.selectedCountry.value.toLowerCase() === Constants.caCountryCode ? this.renderDropDownFilterBlock('States') : null
            ]
        });
    }
    setCategoryList() {
        const defaultCategories = this.props.dataMap.categories.default;
        if (this.state.productData && Object.keys(this.state.productData).length > 0) {
            const dynamicCategories = getCategoryListByProductId(this.state.productData, this.props.dataMap);
            if (dynamicCategories) {
                return dynamicCategories;
            }
        }
        return defaultCategories;
    }
    renderImpl() {
        const hideIndustriesAndProducts = this.props.isEmbedded && shouldHideIndustriesAndProducts(this.props.embedHost);
        const showServiceTypeFilters = this.props.entityType === Constants.EntityType.Service;
        const categoryList = this.setCategoryList();
        return /*#__PURE__*/ _jsxs("div", {
            className: classNames({
                spza_filterContainer: !isEmbedded(),
                spza_filterContainerEmbedded: isEmbedded()
            }),
            role: "navigation",
            "aria-label": "Product Category Filter",
            children: [
                showServiceTypeFilters ? this.renderLocationFilters() : null,
                !hideIndustriesAndProducts && showServiceTypeFilters ? this.renderProductBlock('FilterType_Products') : null,
                !showServiceTypeFilters && Object.getOwnPropertyNames(categoryList).length > 0 ? this.renderCategoryBlock('FilterType_Categories', categoryList) : null,
                hideIndustriesAndProducts ? null : this.renderSearchBlock('FilterType_Industries', this.props.dataMap.industries, FilterQuery.industry),
                !hideIndustriesAndProducts && !showServiceTypeFilters ? this.renderProductBlock('FilterType_Products') : null,
                !hideIndustriesAndProducts && !showServiceTypeFilters ? this.renderAppComplianceBlock('FilterType_AppCompliance') : null,
                showServiceTypeFilters ? this.renderSearchBlock('FilterType_ServiceType', this.props.dataMap.serviceTypes, FilterQuery.serviceType) : null
            ]
        });
    }
    getStatesFilterItems(countryCode) {
        const items = countryCode && countryCode.toLowerCase() === Constants.caCountryCode ? serviceOffersSupportedCAStates : serviceOffersSupportedUSStates;
        const filterList = [];
        items.forEach((item)=>filterList.push({
                text: item.name,
                value: item.code
            }));
        return filterList;
    }
    getFirstSupportedCountryIndex() {
        return 1;
    }
    getCountriesFilterItems() {
        const filterCountries = Object.keys(this.props.countriesList).length > 0;
        const filterList = [];
        const firstSupportedCountryIndex = this.getFirstSupportedCountryIndex();
        for(let i = firstSupportedCountryIndex; i < serviceOffersSupportedCountries.length; i++){
            if (!filterCountries || filterCountries && this.props.countriesList[serviceOffersSupportedCountries[`${i}`].countryCode] || serviceOffersSupportedCountries[`${i}`].countryCode === 'ALL') {
                filterList.push({
                    text: serviceOffersSupportedCountries[`${i}`].name,
                    value: serviceOffersSupportedCountries[`${i}`].countryCode
                });
            }
        }
        return filterList;
    }
    getDefaultState() {
        let selectedRegion;
        if (this.props.countryCode && this.props.countryCode.toLowerCase() === Constants.caCountryCode || this.state.selectedCountry && this.state.selectedCountry.value.toLowerCase() === Constants.caCountryCode) {
            // there is some region code present in the query param.
            if (this.props.regionCode) {
                selectedRegion = serviceOffersSupportedCAStates.filter((item)=>{
                    return item.code === this.props.regionCode;
                });
                // the one found in the query param is valid return that
                if (selectedRegion && selectedRegion.length > 0) {
                    return selectedRegion;
                }
            }
        }
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0);
        this.instrument = SpzaInstrumentService.getProvider();
        this.state = this.getInitialState();
    }
}
FilterPane.contextTypes = {
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func,
    buildHref: PropTypes.func
};
